import styles from "./HalloweenDecor.module.scss";
import { PixelGhost, PixelPumpkin, PixelSpider, PixelWeb } from "./pixelSprites";

export default function HalloweenDecor() {
  return (
    <div className={styles.layer} aria-hidden="true">
      <div className={styles.glow} />

      <PixelWeb className={`${styles.web} ${styles.webTopLeft}`} />
      <PixelWeb className={`${styles.web} ${styles.webTopRight}`} />
      <PixelWeb className={`${styles.web} ${styles.webBottomLeft}`} />
      <PixelWeb className={`${styles.web} ${styles.webBottomRight}`} />

      <div className={`${styles.dangle} ${styles.dangleRight}`}>
        <span className={styles.thread} />
        <PixelSpider className={styles.spider} />
      </div>
      <div className={`${styles.dangle} ${styles.dangleLeft}`}>
        <span className={styles.threadLong} />
        <PixelSpider className={`${styles.spider} ${styles.spiderSmall}`} />
      </div>

      <PixelGhost className={`${styles.ghost} ${styles.ghostLeft}`} />
      <PixelGhost className={`${styles.ghost} ${styles.ghostRight}`} />
      <PixelGhost className={`${styles.ghost} ${styles.ghostLow}`} />

      <PixelPumpkin className={`${styles.pumpkin} ${styles.pumpkinCornerLeft}`} />
      <PixelPumpkin className={`${styles.pumpkin} ${styles.pumpkinCornerRight}`} />
    </div>
  );
}
